export default "/images/4898093acc84f6037c1a01478c50fc2d.avif";